export default "__VITE_ASSET__CRaxHaNp__"